/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {Box, Card, CardContent, Radio, FormControl, FormHelperText, RadioGroup, InputLabel, FormControlLabel} from '@deere/fuel-react';
import {useState} from 'react';
import {constants} from '../../util/constants';

const FormCollab = ({
    errors, register
}) => {
    const [selectedValue, setSelectedValue] = useState(undefined);
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const radioGroupCard = (<Box>
        <Card>
            <CardContent>
                <FormControl
                    error={Boolean(errors.customOption?.message !== undefined && errors.customOption?.message !== '')}
                    required={true}
                >
                    <InputLabel htmlFor='customOption'>{'Select a Collab option where the issue was found.'}</InputLabel>
                    <RadioGroup
                        aria-labelledby='demo-controlled-radio-buttons-group'
                        name='customOption'
                        onChange={handleChange}
                        row
                        value={selectedValue}
                    >
                        <FormControlLabel
                            control={<Radio {...register('customOption')}/>}
                            label='Part Plan Search'
                            value={constants.COLLAB_OPTIONS.partPlan}
                        />
                        <FormControlLabel
                            control={<Radio {...register('customOption')}/>}
                            label='Supplier Change Request'
                            value={constants.COLLAB_OPTIONS.changeRequest}
                        />
                        <FormControlLabel
                            control={<Radio {...register('customOption')}/>}
                            label='Other'
                            value={constants.COLLAB_OPTIONS.other}
                        />
                    </RadioGroup>
                    <FormHelperText>{errors.customOption?.message}</FormHelperText>
                </FormControl>
            </CardContent>
        </Card>
    </Box>);

    return radioGroupCard;
};

export default FormCollab;
